import { useEffect, useState } from 'react';

export const useLoadingStates = (loadingStates: boolean[]) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(loadingStates.some((state) => state));
  }, [loadingStates]);

  return isLoading;
};
